/**
 * Category Menu
 *
 * Handles the functionality for the product category mega menu
 * with pane swapping between different category levels.
 */
class CategoryMenu extends HTMLElement {
  /**
   * Initialize the component when connected to the DOM
   */
  connectedCallback() {
    this.triggers = this.querySelectorAll('[data-category-trigger]');
    this.panes = this.querySelectorAll('[data-category-pane]');

    this.addEventListeners();
  }

  /**
   * Add event listeners to the triggers
   */
  addEventListeners() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this));
    });
  }

  /**
   * Handle click on category trigger
   * @param {Event} event - The click event
   */
  handleTriggerClick(event) {
    const categoryId = event.currentTarget.getAttribute('data-category-trigger');
    this.showPane(categoryId);
  }

  /**
   * Show the pane for the selected category
   * @param {string} categoryId - The ID of the category to show
   */
  showPane(categoryId) {
    // Update triggers
    this.triggers.forEach((trigger) => {
      const isSelected = trigger.getAttribute('data-category-trigger') === categoryId;
      trigger.setAttribute('aria-selected', isSelected);
    });

    // Update panes
    this.panes.forEach((pane) => {
      if (pane.getAttribute('data-category-pane') === categoryId) {
        pane.setAttribute('aria-hidden', 'false');
      } else {
        pane.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

customElements.define('category-menu', CategoryMenu);
